module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/keystrokes-e1b6fd634a67684b42c13da59acd258c.svg";